import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { StoreProvider } from '../../components';

import TopOffersList from './TopOffersList';

export class TopOffersContainerView extends Component {
  render() {
    const { topOffers: connection } = this.props.lists;
    const offers = connection.edges.map((e) => e.node);

    return (
      <div className="offers">
        <div className="header">
          <h2>Top Offers</h2>
        </div>

        <TopOffersList
          offers={offers}
          relay={this.props.relay}
          lists={this.props.lists}
        />
      </div>
    );
  }
}

const TopOffersContainer = createFragmentContainer(TopOffersContainerView, {
  lists: graphql`
    fragment TopOffersContainer_lists on Lists {
      topOffers(first: 50) {
        edges {
          node {
            id
            ...TopOfferCell_offer
          }
        }
      }
    }
  `,
});

export default class TopOffers extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={TopOffersContainer}
        query={graphql`
          query TopOffersContainerQuery {
            lists {
              ...TopOffersContainer_lists
            }
          }
        `}
      />
    );
  }
}
